module.exports = __webpack_public_path__ + "assets/f52cddfba8ef57deff8c8519db673bbb.json";